import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export default function SurpriseGiftModal({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            data-testid="surprise-gift-backdrop"
          />

          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 50 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none"
          >
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 pointer-events-auto relative overflow-hidden" data-testid="surprise-gift-modal">
              {/* Background Animation */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 via-pink-500/10 to-yellow-500/10 animate-pulse" />
              
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10"
                data-testid="close-surprise-gift-button"
              >
                <X className="w-6 h-6" />
              </button>

              {/* Content */}
              <div className="relative z-10 text-center">
                {/* Animated Gift Icon */}
                <motion.div
                  animate={{
                    scale: [1, 1.2, 1],
                    rotate: [0, 10, -10, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: 'easeInOut'
                  }}
                  className="inline-block mb-6"
                >
                  <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-xl">
                    <Gift className="w-12 h-12 text-white" />
                  </div>
                </motion.div>

                {/* Sparkles */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2">
                  <Sparkles className="w-8 h-8 text-yellow-400 animate-pulse" />
                </div>

                <h2 className="text-4xl font-bold text-[#1A1A1A] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  Félicitations !
                </h2>
                
                <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-6 mb-6">
                  <p className="text-xl font-semibold text-purple-900 mb-2">
                    Cadeau Surprise Débloqué !
                  </p>
                  <p className="text-gray-700">
                    3 cartes complétées ! Le client mérite un cadeau spécial de votre part.
                  </p>
                </div>

                <Button
                  onClick={onClose}
                  className="w-full py-6 text-lg font-semibold rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600"
                  data-testid="surprise-gift-ok-button"
                >
                  Super !
                </Button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}